import React from "react";
import { Container, Navbar } from "react-bootstrap";
import WbsHeaderLogo from "../../img/wbs-group-logo.png";
import { Link } from "react-router-dom";

const Topbar = (): JSX.Element => {
  return (
    <Navbar className="lzk-primary-navbar shadow-sm" bg="light" expand="xl" fixed="top">
      <Container>
        <Navbar.Brand>
          <Link to="/"><img className="lzk-header-logo" alt="lzk-header-logo" src={WbsHeaderLogo} /></Link>
        </Navbar.Brand>
      </Container>
    </Navbar>
  );
};

export default Topbar;
